import agentSearch from 'locales/en/agentSearch.json';
import common from 'locales/en/common.json';
import connectionRequest from 'locales/en/connectionRequest.json';
import connectWithAgent from 'locales/en/connectWithAgent.json';
import expCommercial from 'locales/en/expCommercial.json';
import expCommercialCa from 'locales/en-CA/expCommercialCa.json';
import expInService from 'locales/en/expInService.json';
import expRealtyCa from 'locales/en/expRealtyCa.json';
import expRealtyUs from 'locales/en/expRealtyUs.json';
import formError from 'locales/en/formError.json';
import homeAppraisal from 'locales/en/homeAppraisal.json';
import internalLinks from 'locales/en/internalLinks.json';
import joinExpCa from 'locales/en/join.exprealtyCA.json';
import joinExpUs from 'locales/en/join.exprealtyUS.json';
import listing from 'locales/en/listing.json';
import listingExpCommercial from 'locales/en/listing.expCommercial.json';
import home from 'locales/en/home.json';
import modal from 'locales/en/modal.json';
import search from 'locales/en/search.json';
import { LeafPaths } from './LeafPaths';
import { UpperSnake } from './upperSnake';
import { WithTranslation } from 'next-i18next';

//#region Private Constants
const AGENT_SEARCH_NAMESPACE_KEY = 'AGENT_SEARCH' as const;
const COMMON_NAMESPACE_KEY = 'COMMON' as const;
const CONNECTION_REQUEST_NAMESPACE_KEY = 'CONNECTION_REQUEST' as const;
const CONNECT_WITH_AGENT_NAMESPACE_KEY = 'CONNECT_WITH_AGENT' as const;
const EXP_COMMERCIAL_NAMESPACE_KEY = 'EXP_COMMERCIAL' as const;
const EXP_COMMERCIAL_CA_NAMESPACE_KEY = 'EXP_COMMERCIAL_CA' as const;
const EXP_IN_SERVICE_NAMESPACE_KEY = 'EXP_IN_SERVICE' as const;
const EXP_REALTY_CA_NAMESPACE_KEY = 'EXP_REALTY_CA' as const;
const EXP_REALTY_US_NAMESPACE_KEY = 'EXP_REALTY_US' as const;
const FORM_ERROR_NAMESPACE_KEY = 'FORM_ERROR' as const;
const HOME_APPRAISAL_NAMESPACE_KEY = 'HOME_APPRAISAL' as const;
const INTERNAL_LINKS_NAMESPACE_KEY = 'INTERNAL_LINKS' as const;
const JOIN_EXP_CA_NAMESPACE_KEY = 'JOIN_EXP_CA' as const;
const JOIN_EXP_US_NAMESPACE_KEY = 'JOIN_EXP_US' as const;
const LISTING_NAMESPACE_KEY = 'LISTING' as const;
const MODAL_NAMESPACE_KEY = 'MODAL' as const;
const LISTING_EXP_COMMERCIAL_NAMESPACE_KEY = 'LISTING_EXP_COMMERCIAL' as const;
const HOME_NAMESPACE_KEY = 'HOME' as const;
const SEARCH_NAMESPACE_KEY = 'SEARCH' as const;
//#endregion

//#region Public Types
export const AGENT_SEARCH_NAMESPACE = 'agentSearch' as const;
export const COMMON_NAMESPACE = 'common' as const;
export const CONNECTION_REQUEST_NAMESPACE = 'connectionRequest' as const;
export const CONNECT_WITH_AGENT_NAMESPACE = 'connectWithAgent' as const;
export const EXP_COMMERCIAL_NAMESPACE = 'expCommercial' as const;
export const EXP_COMMERCIAL_CA_NAMESPACE = 'expCommercialCa' as const;
export const EXP_IN_SERVICE_NAMESPACE = 'expInService' as const;
export const EXP_REALTY_CA_NAMESPACE = 'expRealtyCa' as const;
export const EXP_REALTY_US_NAMESPACE = 'expRealtyUs' as const;
export const FORM_ERROR_NAMESPACE = 'formError' as const;
export const HOME_APPRAISAL_NAMESPACE = 'homeAppraisal' as const;
export const INTERNAL_LINKS_NAMESPACE = 'internalLinks' as const;
export const JOIN_EXP_CA_NAMESPACE = 'join.exprealtyCA' as const;
export const JOIN_EXP_US_NAMESPACE = 'join.exprealtyUS' as const;
export const LISTING_NAMESPACE = 'listing' as const;
export const MODAL_NAMESPACE = 'modal' as const;
export const LISTING_EXP_COMMERCIAL_NAMESPACE = 'listing.expCommercial' as const;
export const HOME_NAMESPACE = 'home' as const;
export const SEARCH_NAMESPACE = 'search' as const;

export type Namespaces = typeof AGENT_SEARCH_NAMESPACE 
| typeof COMMON_NAMESPACE
| typeof CONNECTION_REQUEST_NAMESPACE
| typeof CONNECT_WITH_AGENT_NAMESPACE
| typeof MODAL_NAMESPACE 
| typeof FORM_ERROR_NAMESPACE 
| typeof EXP_COMMERCIAL_NAMESPACE 
| typeof EXP_COMMERCIAL_CA_NAMESPACE
| typeof EXP_IN_SERVICE_NAMESPACE 
| typeof EXP_REALTY_CA_NAMESPACE 
| typeof EXP_REALTY_US_NAMESPACE 
| typeof JOIN_EXP_CA_NAMESPACE 
| typeof LISTING_NAMESPACE
| typeof HOME_APPRAISAL_NAMESPACE
| typeof JOIN_EXP_US_NAMESPACE 
| typeof LISTING_EXP_COMMERCIAL_NAMESPACE 
| typeof INTERNAL_LINKS_NAMESPACE
| typeof HOME_NAMESPACE
| typeof SEARCH_NAMESPACE;

export const Namespaces = {
  [AGENT_SEARCH_NAMESPACE_KEY]: AGENT_SEARCH_NAMESPACE,
  [COMMON_NAMESPACE_KEY]: COMMON_NAMESPACE,
  [CONNECTION_REQUEST_NAMESPACE_KEY]: CONNECTION_REQUEST_NAMESPACE,
  [CONNECT_WITH_AGENT_NAMESPACE_KEY]: CONNECT_WITH_AGENT_NAMESPACE,
  [MODAL_NAMESPACE_KEY]: MODAL_NAMESPACE,
  [FORM_ERROR_NAMESPACE_KEY]: FORM_ERROR_NAMESPACE,
  [EXP_COMMERCIAL_NAMESPACE_KEY]: EXP_COMMERCIAL_NAMESPACE,
  [EXP_COMMERCIAL_CA_NAMESPACE_KEY]: EXP_COMMERCIAL_CA_NAMESPACE,
  [EXP_IN_SERVICE_NAMESPACE_KEY]: EXP_IN_SERVICE_NAMESPACE,
  [EXP_REALTY_CA_NAMESPACE_KEY]: EXP_REALTY_CA_NAMESPACE,
  [EXP_REALTY_US_NAMESPACE_KEY]: EXP_REALTY_US_NAMESPACE,
  [HOME_APPRAISAL_NAMESPACE_KEY]: HOME_APPRAISAL_NAMESPACE,
  [INTERNAL_LINKS_NAMESPACE_KEY]: INTERNAL_LINKS_NAMESPACE,
  [JOIN_EXP_CA_NAMESPACE_KEY]: JOIN_EXP_CA_NAMESPACE,
  [JOIN_EXP_US_NAMESPACE_KEY]: JOIN_EXP_US_NAMESPACE,
  [LISTING_NAMESPACE_KEY]: LISTING_NAMESPACE,
  [LISTING_EXP_COMMERCIAL_NAMESPACE_KEY]: LISTING_EXP_COMMERCIAL_NAMESPACE,
  [HOME_NAMESPACE_KEY]: HOME_NAMESPACE,
  [SEARCH_NAMESPACE_KEY]: SEARCH_NAMESPACE,
} as const;

/** A union type of all possible paths in the {@link agentSearch 'locales/en/agentSearch.json'} locale file. */
export type agentSearchPaths = LeafPaths<typeof agentSearch, `${typeof Namespaces.AGENT_SEARCH}:`>;

/** A union type of all possible paths in the {@link common 'locales/en/common.json'} locale file. */
export type commonPaths = LeafPaths<typeof common, `${typeof Namespaces.COMMON}:`>;

/** A union type of all possible paths in the {@link connectionRequest 'locales/en/connectionRequest.json'} locale file. */
export type connectionRequestPaths = LeafPaths<typeof connectionRequest, `${typeof Namespaces.CONNECTION_REQUEST}:`>;

/** A union type of all possible paths in the {@link connectWithAgent 'locales/en/connectWithAgent.json'} locale file. */
export type connectWithAgentPaths = LeafPaths<typeof connectWithAgent, `${typeof Namespaces.CONNECT_WITH_AGENT}:`>;

/** A union type of all possible paths in the {@link expCommercial 'locales/en/expCommercial.json'} locale file. */
export type expCommercialPaths = LeafPaths<typeof expCommercial, `${typeof Namespaces.EXP_COMMERCIAL}:`>;

/** A union type of all possible paths in the {@link expInService 'locales/en/expInService.json'} locale file. */
export type expInServicePaths = LeafPaths<typeof expInService, `${typeof Namespaces.EXP_IN_SERVICE}:`>;

/** A union type of all possible paths in the {@link expRealtyCa 'locales/en/expRealtyCa.json'} locale file. */
export type expRealtyCaPaths = LeafPaths<typeof expRealtyCa, `${typeof Namespaces.EXP_REALTY_CA}:`>;

/** A union type of all possible paths in the {@link expRealtyUs 'locales/en/expRealtyUs.json'} locale file. */
export type expRealtyUsPaths = LeafPaths<typeof expRealtyUs, `${typeof Namespaces.EXP_REALTY_US}:`>;

/** A union type of all possible paths in the {@link formError 'locales/en/formError.json'} locale file. */
export type formErrorPaths = LeafPaths<typeof formError, `${typeof Namespaces.FORM_ERROR}:`>;

/** A union type of all possible paths in the {@link homeAppraisal 'locales/en/homeAppraisal.json'} locale file. */
export type homeAppraisalPaths = LeafPaths<typeof homeAppraisal, `${typeof Namespaces.HOME_APPRAISAL}:`>;

/** A union type of all possible paths in the {@link internalLinks 'locales/en/internalLinks.json'} locale file. */
export type internalLinksPaths = LeafPaths<typeof internalLinks, `${typeof Namespaces.INTERNAL_LINKS}:`>;

/** A union type of all possible paths in the {@link joinExpCa 'locales/en/join.exprealtyCA.json'} locale file. */
export type joinExpCaPaths = LeafPaths<typeof joinExpCa, `${typeof Namespaces.JOIN_EXP_CA}:`>;

/** A union type of all possible paths in the {@link joinExpUs 'locales/en/join.exprealtyUS.json'} locale file. */
export type joinExpUsPaths = LeafPaths<typeof joinExpUs, `${typeof Namespaces.JOIN_EXP_US}:`>;

/** A union type of all possible paths in the {@link listing 'locales/en/listing.json'} locale file. */
export type listingPaths = LeafPaths<typeof listing, `${typeof Namespaces.LISTING}:`>;

/** A union type of all possible paths in the {@link modal 'locales/en/modal.json'} locale file. */
export type modalPaths = LeafPaths<typeof modal, `${typeof Namespaces.MODAL}:`>;

/** A union type of all possible paths in the {@link listingExpCommercial 'locales/en/listing.expCommercial.json'} locale file. */
export type listingExpCommercialPaths = LeafPaths<typeof listingExpCommercial, `${typeof Namespaces.LISTING_EXP_COMMERCIAL}:`>;

/** A union type of all possible paths in the {@link home 'locales/en/home.json'} locale file. */
export type homePaths = LeafPaths<typeof home, `${typeof Namespaces.HOME}:`>;

/** A union type of all possible paths in the {@link search 'locales/en/search.json'} locale file. */
export type searchPaths = LeafPaths<typeof search, `${typeof Namespaces.SEARCH}:`>;

/**
 * A union type of all possible paths in the locale files:
 * - {@link agentSearch 'locales/en/agentSearch.json'}
 * - {@link common 'locales/en/common.json'}
 * - {@link connectionRequest 'locales/en/connectionRequest.json'}
 * - {@link connectWithAgent 'locales/en/connectWithAgent.json'}
 * - {@link expCommercial 'locales/en/expCommercial.json'}
 * - {@link expInService 'locales/en/expInService.json'}
 * - {@link expRealtyCa 'locales/en/expRealtyCa.json'}
 * - {@link expRealtyUs 'locales/en/expRealtyUs.json'}
 * - {@link formError 'locales/en/formError.json'}
 * - {@link homeAppraisal 'locales/en/homeAppraisal.json'}
 * - {@link internalLinks 'locales/en/internalLinks.json'}
 * - {@link joinExpCa 'locales/en/join.exprealtyCA.json'}
 * - {@link joinExpUs 'locales/en/join.exprealtyUS.json'}
 * - {@link listing 'locales/en/listing.json'}
 * - {@link modalPaths 'locales/en/modal.json'}
 * - {@link listingExpCommercial 'locales/en/listing.expCommercial.json'}
 * - {@link home 'locales/en/home.json'}
 * - {@link search 'locales/en/search.json'}
 */
export type LocalePaths =
  | agentSearchPaths
  | commonPaths
  | connectionRequestPaths
  | connectWithAgentPaths
  | expCommercialPaths
  | expInServicePaths
  | expRealtyCaPaths
  | expRealtyUsPaths
  | formErrorPaths
  | homeAppraisalPaths
  | internalLinksPaths
  | joinExpCaPaths
  | joinExpUsPaths
  | listingPaths
  | modalPaths
  | listingExpCommercialPaths
  | homePaths
  | searchPaths;

/**
 * A type that extends a given type with a {@link WithTranslation} property from next-i18next.
 *
 * This utility type is used to add internationalization capabilities to component props.
 * It combines the provided props type with the WithTranslation interface, which includes
 * properties like `t` (translation function), `i18n` (i18n instance), and `ready` (loading state).
 *
 * @template P - The base props type to extend (defaults to unknown)
 *
 * @example
 * ```tsx
 * type MyComponentProps = PropsWithTranslation<{
 *   title: string;
 *   description: string;
 * }>;
 *
 * const MyComponent = ({ t, title, description }: MyComponentProps) => {
 *   return (
 *     <div>
 *       <h1>{t('common:title')}</h1>
 *       <p>{t('common:description')}</p>
 *     </div>
 *   );
 * };
 *
 * @see {@link WithTranslation} - The next-i18next interface that provides translation capabilities
 */
export type PropsWithTranslation<P = unknown> = P & WithTranslation;

//#endregion

//#region Public Constants
/** An object which maps all possible paths in the {@link agentSearch 'locales/en/agentSearch.json'} locale file. */
export const LOCALE_AGENT_SEARCH_PATHS = makeLocalePathsObject<typeof agentSearch, `${typeof Namespaces.AGENT_SEARCH}`>(agentSearch, Namespaces.AGENT_SEARCH);

/** An object which maps all possible paths in the {@link common 'locales/en/common.json'} locale file. */
export const LOCALE_COMMON_PATHS = makeLocalePathsObject<typeof common, `${typeof Namespaces.COMMON}`>(common, Namespaces.COMMON);

/** An object which maps all possible paths in the {@link connectionRequest 'locales/en/connectionRequest.json'} locale file. */
export const LOCALE_CONNECTION_REQUEST_PATHS = makeLocalePathsObject<typeof connectionRequest, `${typeof Namespaces.CONNECTION_REQUEST}`>(connectionRequest, Namespaces.CONNECTION_REQUEST);

/** An object which maps all possible paths in the {@link connectWithAgent 'locales/en/connectWithAgent.json'} locale file. */
export const LOCALE_CONNECT_WITH_AGENT_PATHS = makeLocalePathsObject<typeof connectWithAgent, `${typeof Namespaces.CONNECT_WITH_AGENT}`>(connectWithAgent, Namespaces.CONNECT_WITH_AGENT);

/** An object which maps all possible paths in the {@link expCommercial 'locales/en/expCommercial.json'} locale file. */
export const LOCALE_EXP_COMMERCIAL_PATHS = makeLocalePathsObject<typeof expCommercial, `${typeof Namespaces.EXP_COMMERCIAL}`>(expCommercial, Namespaces.EXP_COMMERCIAL);

/** An object which maps all possible paths in the {@link expCommercialCa 'locales/en/expCommercialCa.json'} locale file. */
export const LOCALE_EXP_COMMERCIAL_CA_PATHS = makeLocalePathsObject<typeof expCommercialCa, `${typeof Namespaces.EXP_COMMERCIAL_CA}`>(expCommercialCa, Namespaces.EXP_COMMERCIAL_CA);

/** An object which maps all possible paths in the {@link expInService 'locales/en/expInService.json'} locale file. */
export const LOCALE_EXP_IN_SERVICE_PATHS = makeLocalePathsObject<typeof expInService, `${typeof Namespaces.EXP_IN_SERVICE}`>(expInService, Namespaces.EXP_IN_SERVICE);

/** An object which maps all possible paths in the {@link expRealtyCa 'locales/en/expRealtyCa.json'} locale file. */
export const LOCALE_EXP_REALTY_CA_PATHS = makeLocalePathsObject<typeof expRealtyCa, `${typeof Namespaces.EXP_REALTY_CA}`>(expRealtyCa, Namespaces.EXP_REALTY_CA);

/** An object which maps all possible paths in the {@link expRealtyUs 'locales/en/expRealtyUs.json'} locale file. */
export const LOCALE_EXP_REALTY_US_PATHS = makeLocalePathsObject<typeof expRealtyUs, `${typeof Namespaces.EXP_REALTY_US}`>(expRealtyUs, Namespaces.EXP_REALTY_US);

/** An object which maps all possible paths in the {@link formError 'locales/en/formError.json'} locale file. */
export const LOCALE_FORM_ERROR_PATHS = makeLocalePathsObject<typeof formError, `${typeof Namespaces.FORM_ERROR}`>(formError, Namespaces.FORM_ERROR);

/** An object which maps all possible paths in the {@link homeAppraisal 'locales/en/homeAppraisal.json'} locale file. */
export const LOCALE_HOME_APPRAISAL_PATHS = makeLocalePathsObject<typeof homeAppraisal, `${typeof Namespaces.HOME_APPRAISAL}`>(homeAppraisal, Namespaces.HOME_APPRAISAL);

/** An object which maps all possible paths in the {@link internalLinks 'locales/en/internalLinks.json'} locale file. */
export const LOCALE_INTERNAL_LINKS_PATHS = makeLocalePathsObject<typeof internalLinks, `${typeof Namespaces.INTERNAL_LINKS}`>(internalLinks, Namespaces.INTERNAL_LINKS);

/** An object which maps all possible paths in the {@link joinExpCa 'locales/en/join.exprealtyCA.json'} locale file. */
export const LOCALE_JOIN_EXP_CA_PATHS = makeLocalePathsObject<typeof joinExpCa, `${typeof Namespaces.JOIN_EXP_CA}`>(joinExpCa, Namespaces.JOIN_EXP_CA);

/** An object which maps all possible paths in the {@link joinExpUs 'locales/en/join.exprealtyUS.json'} locale file. */
export const LOCALE_JOIN_EXP_US_PATHS = makeLocalePathsObject<typeof joinExpUs, `${typeof Namespaces.JOIN_EXP_US}`>(joinExpUs, Namespaces.JOIN_EXP_US);

/** An object which maps all possible paths in the {@link listing 'locales/en/listing.json'} locale file. */
export const LOCALE_LISTING_PATHS = makeLocalePathsObject<typeof listing, `${typeof Namespaces.LISTING}`>(listing, Namespaces.LISTING);

/** An object which maps all possible paths in the {@link modal 'locales/en/modal.json'} locale file. */
export const LOCALE_MODAL_PATHS = makeLocalePathsObject<typeof modal, `${typeof Namespaces.MODAL}`>(modal, Namespaces.MODAL);

/** An object which maps all possible paths in the {@link listingExpCommercial 'locales/en/listing.expCommercial.json'} locale file. */
export const LOCALE_LISTING_EXP_COMMERCIAL_PATHS = makeLocalePathsObject<typeof listingExpCommercial, `${typeof Namespaces.LISTING_EXP_COMMERCIAL}`>(listingExpCommercial, Namespaces.LISTING_EXP_COMMERCIAL);


/** An object which maps all possible paths in the {@link home 'locales/en/home.json'} locale file. */
export const LOCALE_HOME_PATHS = makeLocalePathsObject<typeof home, `${typeof Namespaces.HOME}`>(home, Namespaces.HOME);

/** An object which maps all possible paths in the {@link search 'locales/en/search.json'} locale file. */
export const LOCALE_SEARCH_PATHS = makeLocalePathsObject<typeof search, `${typeof Namespaces.SEARCH}`>(search, Namespaces.SEARCH);

export enum SiteLanguage {
  English = 'en',
  EnglishCA = 'en-CA',
  French = 'fr',
  FrenchCA = 'fr-CA',
  Spanish = 'es'
}

export enum SiteLanguageLabel {
  en = 'English',
  'en-CA' = 'English (Canada)',
  fr = 'French',
  'fr-CA' = 'French (Canada)',
  es = 'Spanish'
}

export const LOCALES = [SiteLanguage.English, SiteLanguage.EnglishCA, SiteLanguage.French, SiteLanguage.FrenchCA, SiteLanguage.Spanish] as const;
//#endregion

//#region Private Functions

/**
 * A function which creates an object which maps all possible paths in a locale file to a string.
 *
 * @param obj The object to map.
 * @param prefix The prefix to add to the paths.
 * @returns An object which maps all possible paths in the locale file to a string.
 */
export function makeLocalePathsObject<T extends object, Prefix extends string = ''>(
  obj: T,
  prefix: Prefix
): {[P in LeafPaths<T> as UpperSnake<P>]: `${Prefix}:${P}` } {
  const out = {} as {[P in LeafPaths<T> as UpperSnake<P>]: `${Prefix}:${P}` };

  function recurse(o: object, pfx: string) {
    for (const key of Object.keys(o)) {
      const full = pfx ? `${pfx}.${key}` : key;
      if (o[key] && typeof o[key] === 'object') {
        recurse(o[key], full);
      } else {
        const name = full.toUpperCase().replace(/\./g, '_');
        out[name] = prefix ? `${prefix}:${full}` : full;
      }
    }
  }

  recurse(obj, '');
  return out;
}
//#endregion